module.exports = __webpack_public_path__ + "static/media/trial1.e89fcbca.mp3";